import { Box, CircularProgress, styled, Button, Fade } from "@mui/material";
import { Container, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import ExamCard from "./ExamCard";
import StarIcon from "@mui/icons-material/Star";
import ModeCommentIcon from "@mui/icons-material/ModeComment";
import RatingCard from "./RatingCard";
import RatingCardSkeleton from "./RatinCardSkeleton";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import { Link } from "react-router-dom";
const reviews = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1];

const IconBox = styled(Box)({
  height: "27px",
  width: "34px",
  borderRadius: "5px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "10px",
});
const IconRight = styled(Button)({
  width: "30px",
  background: "#27B1BB",
  borderRadius: "0px 10px 10px 0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
});
const IconLeft = styled(Button)({
  width: "30px",
  background: "#FFFFFF",
  borderRadius: "10px 0px 0px 10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
});
export const Title = styled(Typography)(({ theme }) => ({
  margin: "20px 0",
  marginRight: "10px !important",
  fontSize: "16px",
  fontFamily: "Poppins",
  fontWeight: 700,
  textAlign: "center",

  [theme.breakpoints.down("md")]: {
    fontSize: "26px",
  },

  [theme.breakpoints.down("sm")]: {
    margin: "5px 0",
  },
}));

function ExamsSection({ loading, exams }) {
  const [newsortedexams, setNewSortedExams] = useState([]);
  const [sortOrder, setSortOrder] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const examsPerPage = 10;
  const [iconRightDisabled, setIconRightDisabled] = useState(false);
  const examsSectionRef = useRef(null);
  const [containerMinHeight, setContainerMinHeight] = useState("480px");
  const [isLoading, setIsLoading] = useState(false);

  // Reset pagination when exams change
  useEffect(() => {
    setCurrentPage(1);
    setNewSortedExams(exams);
    setIconRightDisabled(false);
  }, [exams]);

  useEffect(() => {
    if (sortOrder === "newest") {
      const sortedExams = [...newsortedexams].sort(
        (a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn)
      );
      setNewSortedExams(sortedExams);
    } else if (sortOrder === "oldest") {
      const sortedExams = [...newsortedexams].sort(
        (a, b) => new Date(a.CreatedOn) - new Date(b.CreatedOn)
      );
      setNewSortedExams(sortedExams);
    }
  }, [sortOrder, exams]);

  useEffect(() => {
    const totalPages = Math.ceil(newsortedexams.length / examsPerPage);
    const isLastPage = currentPage === totalPages;
    const itemsOnLastPage =
      newsortedexams.length % examsPerPage || examsPerPage;

    if (isLastPage && itemsOnLastPage < examsPerPage) {
      const newMinHeight = `${Math.max(280, itemsOnLastPage * 48 + 200)}px`;
      setContainerMinHeight(newMinHeight);
    } else {
      setContainerMinHeight("480px");
    }
  }, [currentPage, newsortedexams, examsPerPage]);

  const scrollToExams = () => {
    if (examsSectionRef.current) {
      examsSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handlePagination = (newPage) => {
    setIsLoading(true);
    setTimeout(() => {
      setCurrentPage(newPage);
      scrollToExams();
      setIsLoading(false);
    }, 300); // Delay to show loading spinner
  };

  const handleIconLeftClick = (event) => {
    event.preventDefault();
    if (currentPage > 1) {
      handlePagination(currentPage - 1);
    }
    setIconRightDisabled(false);
  };

  const handleIconRightClick = (event) => {
    event.preventDefault();
    const maxPage = Math.ceil(newsortedexams.length / examsPerPage);
    if (currentPage < maxPage) {
      handlePagination(currentPage + 1);
    }
    if (currentPage === maxPage - 1) {
      setIconRightDisabled(true);
    }
  };

  const indexOfLastExam = currentPage * examsPerPage;
  const indexOfFirstExam = indexOfLastExam - examsPerPage;
  const displayedExams = newsortedexams.slice(
    indexOfFirstExam,
    indexOfLastExam
  );

  return (
    <Container>
      <Grid>
        <Grid
          ref={examsSectionRef}
          item
          md={5}
          xs={12}
          sx={{
            background: "#EBEBEB",
            borderRadius: "5px",
            width: "100%",
            minHeight: containerMinHeight,
            display: "flex",
            flexDirection: "column",
            tabIndex: 0,
          }}
        >
          <Stack
            width="100%"
            direction="row"
            justifyContent="center"
            marginTop={"20px"}
          >
            <Button
              variant="contained"
              sx={{
                marginTop: "20px",
                borderRadius: "2px 0px 0px 2px",
                background: "#27B1BB !important",
                minWidth: {
                  sm: "120.09px !important",
                  xs: "120.09px !important",
                  md: "240.26px !important",
                },
                minHeight: { sm: "53px", xs: "53px" },
                fontSize: { xs: "8px", md: "18px", sm: "15px" },
                lineHeight: { xs: "10px", md: "22px", lg: "15px" },
              }}
            >
              All Exams
            </Button>
            <Button
              variant="contained"
              sx={{
                marginTop: "20px",
                borderRadius: "0px 2px 2px 0px",
                background: "#FFFFFF !important",
                color: "#27B1BB",
                minWidth: {
                  sm: "120.09px !important",
                  xs: "120.09px !important",
                  md: "240.26px !important",
                },
                minHeight: { sm: "53px", xs: "53px" },
                maxWidth: {
                  md: "240.26px !important",
                  sm: "120.09px !important",
                  xs: "120.09px !important",
                },
                fontSize: { xs: "8px", sm: "10px", md: "18px" },
                lineHeight: { xs: "10px", sm: "12px", md: "22px" },
              }}
            >
              Most Discussed Exam Topics
            </Button>
          </Stack>
          <Box
            sx={{
              display: "flex",
              flexDirection: { md: "row", sm: "column", xs: "column" },
              alignItems: { md: "center" },
              justifyContent: "flex-end",
              marginBottom: { sx: "15px", xs: "15px" },
            }}
          >
            <Title
              sx={{
                fontSize: "16px !important",
                marginTop: { sm: "30px !important", xs: "30px !important" },
                marginRight: { sm: "10px", xsL: "10px", md: "0px" },
              }}
            >
              Sort By:
            </Title>
            <Stack
              width="auto"
              direction="row"
              justifyContent={{ md: "flex-end", sm: "center", xs: "center" }}
              marginTop={{ md: "10px" }}
            >
              <Button
                variant="contained"
                sx={{
                  borderRadius: "10px 0px 0px 10px",
                  background:
                    sortOrder === "newest"
                      ? "#27B1BB !important"
                      : "#FFFFFF !important",
                  color: sortOrder === "newest" ? "#FFFFFF" : "#27B1BB",
                  fontSize: { xs: "8px", md: "18px" },
                  lineHeight: { xs: "10px", md: "22px" },
                }}
                onClick={() => setSortOrder("newest")}
              >
                Newest
              </Button>
              <Button
                variant="contained"
                sx={{
                  marginRight: "30px",
                  borderRadius: "0px 10px 10px 0px",
                  background:
                    sortOrder === "oldest"
                      ? "#27B1BB !important"
                      : "#FFFFFF !important",
                  color: sortOrder === "oldest" ? "#FFFFFF" : "#27B1BB",
                  fontSize: { xs: "8px", md: "18px" },
                  lineHeight: { xs: "10px", md: "22px" },
                }}
                onClick={() => setSortOrder("oldest")}
              >
                Oldest
              </Button>
            </Stack>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            {isLoading ? (
              <div
                style={{
                  minHeight: "480px",
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Fade in={!isLoading} timeout={500}>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    justifyContent: "center",
                    flexDirection: "row",
                  }}
                >
                  {loading
                    ? Array.from(new Array(10)).map((_, index) => (
                        <Grid
                          item
                          key={index}
                          md={5}
                          xs={12}
                          sx={{ marginRight: { md: "80px" } }}
                        >
                          <RatingCardSkeleton />
                        </Grid>
                      ))
                    : displayedExams.map((item, i) => (
                        <Grid
                          item
                          key={i}
                          md={5}
                          xs={12}
                          sx={{ marginRight: { md: "80px" } }}
                        >
                          <RatingCard item={item} />
                        </Grid>
                      ))}
                </Grid>
              </Fade>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              padding: "10px 0",
            }}
          >
            {newsortedexams.length > examsPerPage && (
              <>
                <IconLeft
                  onClick={handleIconLeftClick}
                  disabled={currentPage === 1}
                >
                  <WestIcon sx={{ color: "#1A1F22" }} />
                </IconLeft>
                <IconRight
                  onClick={handleIconRightClick}
                  disabled={iconRightDisabled}
                >
                  <EastIcon sx={{ color: "white" }} />
                </IconRight>
              </>
            )}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export default ExamsSection;
